import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/routes';
import store from "@/store";
import * as clirMiddleware from "@/clir/middlewares";
import * as appMiddleware from "@/middleware";
import getKey from '@/clir/utils/getKey';

const middleware = {
    ...clirMiddleware,
    ...appMiddleware,
};

Vue.use(Router);

const base = process.env.NODE_ENV === "production" ? `/${process.env.VUE_APP_APPLICATION_NAME}/front` : '';

const router = new Router(
    {
        base,
        mode: "history",
        routes,
    }
);

const middlewarePipeline = (context, middleware, index) => {
    const nextMiddleware = middleware[index];
    if (!nextMiddleware) {
        return context.next;
    }
    return () => {
        const nextPipeline = middlewarePipeline(context, middleware, index + 1);
        nextMiddleware({ ...context, next: nextPipeline })
    };
};

router.beforeEach(async (to, from, next) => {
    const routeMiddlewares = Object.keys(getKey(to, 'meta.middleware', {}));

    if (!store.getters['user/isAuthenticated']) {
        await store.dispatch('user/authMe', to);
    }
    const mw = routeMiddlewares.map(key => {
        return middleware[`${key}`];
    }).filter(mwFunction => (typeof mwFunction === 'function'));
    mw.push(middleware.error);
    const context = {
        to,
        from,
        next,
        store,
    };
    return mw[0]({
        ...context,
        next: middlewarePipeline(context, mw, 1),
    });
});

router.afterEach((to) => {
    const appTitle = process.env.VUE_APP_TITLE || 'Projet VueJS';
    const metaTitle = getKey(to, 'meta.title', null);
    let title = '';
    if (to.path === '/' || !metaTitle) {
        title = appTitle;
    } else {
        title = `${metaTitle} | ${appTitle}`;
    }
    Vue.nextTick(() => {
        document.title = title;
    });
});

export default router;